let successMessage = false;
let quizValid = false;
let bgModalPortfolio = false;

var acc = document.getElementsByClassName("quiz__switch__item"), i;

for (i = 0; i < acc.length; i++) {

  acc[i].onclick = function() {

    for (j = 0; j < acc.length; j++) {

      if (acc[j] !== this) {
        acc[j].classList.remove("active");

      } else {
        this.classList.toggle("active");
      }

    }
  }

}


var steps = [false, false, false, false, false, false, false, false, false];
var curr_step = 0;

var int_val = 0; //для проверки площади


// возможность возвращаться к предыдущему вопросу
function set_history(index) {
	if (!(window.history && history.pushState))	{
		return false;
	}
	if (steps[index] == false) {
		history.pushState({'step_x': index}, null, window.location.href);
		steps[index] = true;
	}
}


// переходы по шагам
function to_step(index, need_push) {
	curr_step = index;
	for (var i = 0; i < steps.length; i++) {
		if (!$("#step" + i).is(':hidden')) {
			$("#step" + i).hide();
		}
	};
	$("#step" + index).show();

	$("#progress_in").css({width: (100 * index / 4) + "%"});
	$("#curr_step").text("Шаг " + index + " из " + (steps.length - 1));
	
	// Разделение на #step0, #other_steps и #last_step
	if (index + 1 == 7) { // если шаг равен общему количеству шагов
		if (!$("#other_steps").is(':hidden')) {
			$("#other_steps").hide();
			$("#last_step").show();
		}
	} else if (index > 0) { // если шаг больше ноля
		if ($("#other_steps").is(':hidden')) { $("#other_steps").show(); }
		if (!$("#last_step").is(':hidden')) { $("#last_step").hide(); }
	} else if (!$("#other_steps").is(':hidden')) { // если шаг равен нолю
		$("#other_steps").hide();
	} 

	if (need_push) {
		if (index == 2) { $("#area_input").focus();	}	// Фокусировка на поле площадь
		set_history(index);
	}
}

function check_radio_selected(elem_id) {
	obj = document.querySelector('.'+ elem_id +' label.checked');
	if(!(obj)){
		$('.warning__input[data-name="' + elem_id + '"]').each(function(){
			$(this).find('p').css('display', 'block');
		})
		return false;
	}
	$('.warning__input[data-name="' + elem_id + '"]').each(function(){
		$(this).find('p').css('display', 'none');
	})
	return true;
}


function check_input_value(elem_id) {
	obj = $('input[name="' + elem_id + '"]');
	if (obj.length && obj.val() == "")	{
		$('.warning__input[data-name="' + elem_id + '"]').each(function(){
			$(this).find('p').css('display', 'block');
		})
		return false;
	} else {
		$('.warning__input[data-name="' + elem_id + '"]').each(function(){
			$(this).find('p').css('display', 'none');
		})
	}
	return true;
} 



$(document).ready(function() {
	
	jQuery('body').on('change', '#quiz_form', function() {
		
		// Обводка для label input[type=radio]
		$('input[type=radio]').each(function(){
			if ($(this).is(':checked')) {       
				$(this).parent('label').addClass('checked');
			} else {
				$(this).parent('label').removeClass('checked');
			}   
		});
		
		// Обводка для label input[type=checkbox]
		$('input[type=checkbox]').each(function(){
			if ($(this).is(':checked')) {       
				$(this).parent('label').addClass('checked');
			} else {
				$(this).parent('label').removeClass('checked');
			}   
		});
		
	});
	
	// Поле ввода внутри label для input[type=radio]
	$("#up-layer").click(function() { $("#price_input").focus(); });
	
});

// Проверки полей по шагам и уведомления при незаполненных полях
(function($) {

	const form__quiz = document.getElementById('quiz_form');
	
	$(document).ready(function() {
		 to_step(0, true); 
		
	}); // задаем первоначальный индекс
	
	$("#to_step1").click(function(event) {
		event.preventDefault();
		if(check_input_value("your__niche")){
			to_step(1, true);
			quizValid = true;
		} 
	});

	$("#to_step2").click(function(event) {
		event.preventDefault();

		if(check_input_value("other__quiz") || check_radio_selected("checkbox-2")){
			to_step(2, true);
		}
	});

	$("#to_step3").click(function(event) {
		event.preventDefault();
		if(check_radio_selected("checkbox-3")){
			to_step(3, true);
		}
		
	});

	$("#to_step33").click(function(event) {
		event.preventDefault();
		to_step(3, true);
	});

	$("#to_step4").click(function(event) {
		event.preventDefault();
		if(check_radio_selected("checkbox-4")){
			to_step(4, true);
		}
	});

	$("#to_step5").click(function(event) {
		event.preventDefault();
		if(check_input_value("your__name__quiz") && check_input_value("your__number__quiz") ){
			to_step(5, true);
		}
	});

	$("#to_step6").click(function(event) {
		event.preventDefault();
		if(check_radio_selected("qsi__wrapp")){
			$("#quiz_form").submit();
		}
	});

	$('#quiz_form').submit(function (event) {
		event.preventDefault();
		quizValid = false;

		// Шаг 1/6

		var niche = $(this).find("input[name='your__niche']").val();
		var site__link;
		if($(this).find("input[name='your__site__link']").val() == ""){ var site__link = "Нет"; } else { site__link = $(this).find("input[name='your__site__link']").val(); }
		var social__link;
		if($(this).find("input[name='your__social__link']").val() == ""){ var social__link = "Нет"; } else { social__link = $(this).find("input[name='your__social__link']").val(); }

		// Шаг 2/6
		var elems1 = document.querySelectorAll(".checkbox-2 label.checked input[type='checkbox']");
		var checkbox__2 = [].map.call(elems1, function(obj) {
			return obj.value;
		});

		var checkbox__2__val = checkbox__2.join();
		if($(this).find("input[name='other__quiz']").val() == ""){ var other__quiz = "Нет"; } else { other__quiz = $(this).find("input[name='other__quiz']").val(); }

		// Шаг 3/6
		var elems2 = document.querySelectorAll(".checkbox-3 label.checked input[type='checkbox']");
		var checkbox__3 = [].map.call(elems2, function(obj) {
			return obj.value;
		});

		var checkbox__3__val = checkbox__3.join();

		// Шаг 4/6
		var elems3 = document.querySelectorAll(".checkbox-4 label.checked input[type='checkbox']");
		var checkbox__4 = [].map.call(elems3, function(obj) {
			return obj.value;
		});

		var checkbox__4__val = checkbox__4.join();

		// Шаг 5/6
		var name = $(this).find("input[name='your__name__quiz']").val();
		var number = $(this).find("input[name='your__number__quiz']").val();

		// Шаг 6/6
		var checkbox__5__val = $(this).find(".quiz__switch__item label.checked input[type='checkbox']").val();
		
		$.ajax({
			type:'POST',
			async: true,
			cache: false,
			data:{
				action:'send_callback_form',

				// Шаг 1/6
				niche: niche,
				site__link: site__link,
				social__link: social__link,

				// Шаг 2/6
				checkbox__2__val: checkbox__2__val,
				other__quiz: other__quiz,

				// Шаг 3/6
				checkbox__3__val: checkbox__3__val,

				// Шаг 4/6
				checkbox__4__val: checkbox__4__val,

				// Шаг 5/6
				name: name,
				number: number,

				// Шаг 6/6
				checkbox__5__val: checkbox__5__val,
				
			},
			url: "/wp-admin/admin-ajax.php",
			success: function(data) {
				$(this).html(data);
				to_step(6, true);
				ym(90018441,'reachGoal','quiz');
			}
		});
		return false;

	});


	// для возврата к предыдущему вопросу
	window.addEventListener("popstate", function(e) {
		var step = 0;
		if (e.state) {
			step = e.state.step_x;
		}
		to_step(step);
	});

})(jQuery);

document.addEventListener( 'wpcf7submit', function( event ){
	event.stopPropagation();
	
})

var wpcf7Elm = document.querySelector( '.modal__wrapp[data-target="price"] .modal__content' );

wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
	event.stopPropagation();
	var FormOff = $(this).find('.price__form');
	var MessageOff = $(this).find('.wpcf7-response-output');
	var successMessageOn = $(this).find('.success');

	if(successMessage == false){
		FormOff.css('display', 'none');
		MessageOff.css('display', 'none');
		successMessageOn.css('display', 'flex');
		successMessage = true;
		$('.checkbox__default').css('display', 'flex');
	}

	

}, false );

document.addEventListener( 'wpcf7mailsent', function( event ) {
	event.stopPropagation();

	if(successMessage == false){
		event.target.querySelector('.form__wrapp').style.display = 'none';
		event.target.querySelector('.wpcf7-response-output').style.display = 'none';
		event.target.querySelector('.success').style.display = 'flex';
		successMessage = true;
		$('.checkbox__default').css('display', 'flex');
	}

	

}, false );
class Modal {
	constructor(options) {
		let defaultOptions = {
			isOpen: () => {},
			isClose: () => {},
		}
		this.options = Object.assign(defaultOptions, options);
		this.modal = document.querySelector('.modal');
		this.speed = false;
		this.animation = false;
		this.isOpen = false;
		this.modalContainer = false;
		this.previousActiveElement = false;
		this.fixBlocks = document.querySelectorAll('.fix-block');
		this.focusElements = [
			'a[href]',
			'input',
			'button',
			'select',
			'textarea',
			'[tabindex]'
		];
		this.events();
	}

	events() {
		if (this.modal) {
			document.addEventListener('click', function(e){
				const clickedElement = e.target.closest('[data-path]');
				if (clickedElement) {
					let target = clickedElement.dataset.path;
					let animation = clickedElement.dataset.animation;

					if (clickedElement.classList.contains('modal-close')) {
						this.close();
					  }

					let speed = clickedElement.dataset.speed;
					this.animation = animation ? animation : 'fade';
					this.speed = speed ? parseInt(speed) : 300;
					this.modalContainer = document.querySelector(`[data-target="${target}"]`);
					this.open();
					return;
				}
				

				if (e.target.closest('.modal__close')) {
					if(quizValid == false){
						this.close();
						$('.checkbox__default').css('display', 'flex');
						return;
					} else if(quizValid == true) {
						return;
					}
					
				}
			}.bind(this));

			window.addEventListener('keydown', function(e) {
				if (e.keyCode == 27) {
					if (this.isOpen) {
						if(quizValid == false){
							this.close();
						} else if(quizValid == true) {
							return;
						}
					}
				}

				if (e.keyCode == 9 && this.isOpen) {
					this.focusCatch(e);
					return;
				}

			}.bind(this));
		}
	}

	open() {
		this.previousActiveElement = document.activeElement;

		this.modal.style.setProperty('--transition-time', `${this.speed / 1000}s`);
		this.modal.classList.add('is-open');
		this.disableScroll();
		
		this.modalContainer.classList.add('modal-open');
		this.modalContainer.classList.add(this.animation);

		setTimeout(() => {
			this.options.isOpen(this);
			this.modalContainer.classList.add('animate-open');
			this.isOpen = true;
			this.focusTrap();
		}, this.speed);
	}

	close() {
		if (this.modalContainer) {
			this.modalContainer.classList.remove('animate-open');
			this.modalContainer.classList.remove(this.animation);
			this.modal.classList.remove('is-open');
			this.modalContainer.classList.remove('modal-open');

			if(successMessage == true){
				$('.form__wrapp').css('display', 'block');
				$('.price__form').css('display', 'block');
				$('.wpcf7-response-output').css('display', 'none');
				$('.success').css('display', 'none');
				successMessage = false;
			}

			if(bgModalPortfolio == true){
				$('.modal__wrapp[data-target="zayavka"]').find('.order__call').css('background', 'rgba(255, 255, 255, 0.08)');
				bgModalPortfolio = false;
			}

			this.enableScroll();
			this.options.isClose(this);
			this.isOpen = false;
			this.focusTrap();
		}
	}

	focusCatch(e) {
		const focusable = this.modalContainer.querySelectorAll(this.focusElements);
		const focusArray = Array.prototype.slice.call(focusable);
		const focusedIndex = focusArray.indexOf(document.activeElement);

		if (e.shiftKey && focusedIndex === 0) {
			focusArray[focusArray.length - 1].focus();
			e.preventDefault();
		}

		if (!e.shiftKey && focusedIndex === focusArray.length - 1) {
			focusArray[0].focus();
			e.preventDefault();
		}
	}

	focusTrap() {
		const focusable = this.modalContainer.querySelectorAll(this.focusElements);
		if (this.isOpen) {
			focusable[0].focus();
		} else {
			this.previousActiveElement.focus();
		}
	}

	disableScroll() {
		let pagePosition = window.scrollY;
		this.lockPadding();
		document.body.classList.add('disable-scroll');
		document.body.dataset.position = pagePosition;
		document.body.style.top = -pagePosition + 'px';
	}

	enableScroll() {
		let pagePosition = parseInt(document.body.dataset.position, 10);
		this.unlockPadding();
		document.body.style.top = 'auto';
		document.body.classList.remove('disable-scroll');
		window.scroll({ top: pagePosition, left: 0 });
		document.body.removeAttribute('data-position');
	}

	lockPadding() {
		let paddingOffset = window.innerWidth - document.body.offsetWidth + 'px';
		this.fixBlocks.forEach((el) => {
			el.style.paddingRight = paddingOffset;
		});
		document.body.style.paddingRight = paddingOffset;
	}

	unlockPadding() {
		this.fixBlocks.forEach((el) => {
			el.style.paddingRight = '0px';
		});
		document.body.style.paddingRight = '0px';
	}
}

const modal = new Modal({
	isOpen: (modal) => {
		console.log(modal);
		console.log('opened');
	},
	isClose: () => {
		console.log('closed');
	},
});



$('select').each(function(){
	var $this = $(this), numberOfOptions = $(this).children('option').length;
  
	$this.addClass('select-hidden'); 
	$this.wrap('<div class="select"></div>');
	$this.after('<div class="select-styled"></div>');

	var $styledSelect = $this.next('div.select-styled');
	$styledSelect.text($this.children('option').eq(0).text());
  
	var $list = $('<ul />', {
		'class': 'select-options'
	}).insertAfter($styledSelect);
  
	for (var i = 0; i < numberOfOptions; i++) {
		$('<li />', {
			text: $this.children('option').eq(i).text(),
			rel: $this.children('option').eq(i).val()
		}).appendTo($list);
		//if ($this.children('option').eq(i).is(':selected')){
		//  $('li[rel="' + $this.children('option').eq(i).val() + '"]').addClass('is-selected')
		//}
	}
  
	var $listItems = $list.children('li');
  
	$styledSelect.click(function(e) {
		e.stopPropagation();
		$('div.select-styled.active').not(this).each(function(){
			$(this).removeClass('active').next('ul.select-options').hide();
		});
		$(this).toggleClass('active').next('ul.select-options').toggle();
	});
  
	$listItems.click(function(e) {
		e.stopPropagation();
		$styledSelect.text($(this).text()).removeClass('active');
		$this.val($(this).attr('rel'));
		$list.hide();
		//console.log($this.val());
	});
  
	$(document).click(function() {
		$styledSelect.removeClass('active');
		$list.hide();
	});

});

/* data-input-value="Сайты START" */

var submitForm__site = false;
var submitForm__smm = false;
var submitForm__brand = false;
var submitForm__crm = false;

const servicesBtn = document.querySelectorAll('.btn__services');
servicesBtn.forEach(inputValueService => inputValueService.addEventListener('click', function() {
  var serviceValue = inputValueService.getAttribute('data-input-value');
  document.querySelector('input.service__input').value = serviceValue;
  if(serviceValue == "Портфолио" && bgModalPortfolio == false){
	$('.modal__wrapp[data-target="zayavka"]').find('.order__call').css('background', '#2C3F40');
	bgModalPortfolio = true;
  }
}));